<div class="modal-dialog feature-flag-dialog-container">
  <div class="modal-content" cdkTrapFocus>
    <div class="goreact-modal-header">
      <h4 class="modal-title" translate="feature-flags"></h4>
      <button type="button" class="close-btn" (click)="close()" aria-label="Close">
        <i class="ficon-app-x"></i>
      </button>
    </div>
    <div class="goreact-modal-body">
      @for (flag of featureFlags | keyvalue; track flag) {
        <div>
          @if ((flag.value === true || flag.value === false)) {
            <mat-slide-toggle [hideIcon]="true" color="primary" [(ngModel)]="flag.value" (change)="toggleFlag(flag)">
              {{flag.key}}
            </mat-slide-toggle>
          } @else {
            <div class="complexFlag">
              {{flag.key}}
              @for (complexFlag of flag.value | keyvalue; track complexFlag) {
                <div>
                  {{complexFlag.key}}
                  @for (complexValues of complexFlag.value | keyvalue; track complexValues) {
                    <div class="indent">
                      <mat-slide-toggle [hideIcon]="true" color="primary" [(ngModel)]="complexValues.value" (change)="toggleComplexFlag(flag, complexFlag, complexValues)">
                        {{complexValues.key}}
                      </mat-slide-toggle>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
    <div class="goreact-modal-footer">
      <button class="secondary-btn" (click)="reset()" translate="reset-and-close"></button>
      <button class="primary-btn" (click)="close()" translate="common_close" data-cy="common_close"></button>
    </div>
  </div>
</div>
